import { defineComponent as d, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as n, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "3dc466cf-ba9d-47e1-b98b-5508d312a56c" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#3dc466cf-ba9d-47e1-b98b-5508d312a56c)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "m0 0 216.9 301.6L512 512V0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 0 512 512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m256 121 90 270-234-168h288L166 391z"
}, null, -1), x = { fill: "none" }, w = ["r"], z = /* @__PURE__ */ d({
  __name: "gf",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), a = o(() => 256 + t.strokeWidth / 2);
    return (b, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (c(), i("title", k, n(t.flagName), 1)) : f("", !0),
        p,
        g,
        v
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  z as default
};
//# sourceMappingURL=gf-d190c0aa.js.map
